import {
	GetMeQuery,
	GetMyIgnoredMissingDataQuery,
	GetMyLanguagePreferenceQuery,
	GetMyNotificationPreferencesQuery,
	GetPortalBuyersForCustomerDeleteQuery,
	GetUserInvitesQuery,
	GetUsersForSalesPersonLookupQuery,
	GetUsersForUserAdminQuery
} from "~/gql/queries/users.generated";

export const usersEndpoints = {
	AssignUserCustomer: {
		invalidatesTags: ["Users"] as AddTagTypes
	},
	AssignUserCustomers: {
		invalidatesTags: ["Users"] as AddTagTypes
	},
	AssignUserRoutes: {
		invalidatesTags: ["Users"] as AddTagTypes
	},
	AssignUserSites: {
		invalidatesTags: ["Users"] as AddTagTypes
	},
	CreatePortalUser: {
		invalidatesTags: ["Users", "UserInvites"] as AddTagTypes
	},
	CreateUser: {
		invalidatesTags: ["Users"] as AddTagTypes
	},
	CreateUserInvite: {
		invalidatesTags: ["UserInvites"] as AddTagTypes
	},
	DeactivateUser: {
		invalidatesTags: ["Users", "Me"] as AddTagTypes
	},
	DeleteUser: {
		invalidatesTags: ["Users", "Me"] as AddTagTypes
	},
	DeleteUserInvite: {
		invalidatesTags: ["UserInvites"] as AddTagTypes
	},
	GetMe: {
		providesTags: ["Me"] as AddTagTypes,
		transformResponse: (res: GetMeQuery) => res
	},
	GetMyIgnoredMissingData: {
		providesTags: ["Me"] as AddTagTypes,
		transformResponse: (res: GetMyIgnoredMissingDataQuery) => res
	},
	GetMyLanguagePreference: {
		providesTags: ["Me"] as AddTagTypes,
		transformResponse: (res: GetMyLanguagePreferenceQuery) => res
	},
	GetMyNotificationPreferences: {
		providesTags: ["Me"] as AddTagTypes,
		transformResponse: (res: GetMyNotificationPreferencesQuery) => res
	},
	GetPortalBuyersForCustomerDelete: {
		providesTags: ["Users"] as AddTagTypes,
		transformResponse: (res: GetPortalBuyersForCustomerDeleteQuery) => res
	},
	GetUserInvites: {
		providesTags: ["UserInvites"] as AddTagTypes,
		transformResponse: (res: GetUserInvitesQuery) => res
	},
	IgnoreMissingData: {
		invalidatesTags: ["Me"] as AddTagTypes
	},
	ResendUserInvite: {
		invalidatesTags: ["UserInvites"] as AddTagTypes
	},
	GetUsersForSalesPersonLookup: {
		providesTags: ["Users"] as AddTagTypes,
		transformResponse: (res: GetUsersForSalesPersonLookupQuery) => res
	},
	GetUsersForUserAdmin: {
		providesTags: ["Users"] as AddTagTypes,
		transformResponse: (res: GetUsersForUserAdminQuery) => res
	},
	LinkFusionAuthUser: {
		invalidatesTags: ["Users", "Me"] as AddTagTypes
	},
	LinkFusionAuthUserByEmail: {
		invalidatesTags: ["Users", "Me"] as AddTagTypes
	},
	ReactivateUser: {
		invalidatesTags: ["Users", "Me"] as AddTagTypes
	},
	ResetUserLogin: {
		invalidatesTags: ["Users", "UserInvites"] as AddTagTypes
	},
	SetMyLanguagePreference: {
		invalidatesTags: ["Me"] as AddTagTypes
	},
	SetMyNotificationPreferences: {
		invalidatesTags: ["Me", "Notifications"] as AddTagTypes
	},
	RequestMyPhoneVerification: {
		invalidatesTags: ["Me"] as AddTagTypes
	},
	ConfirmMyPhoneVerification: {
		invalidatesTags: ["Me"] as AddTagTypes
	},
	// Accepted exception: nothing in the PWA queries push subscriptions, so registering a device invalidates nothing.
	RegisterMyPushSubscription: {},
	// Accepted exception: same as above, retiring a device is not read anywhere in the PWA.
	RemoveMyPushSubscription: {},
	SetMyProfileImage: {
		invalidatesTags: ["Users", "Me"] as AddTagTypes
	},
	ClearMyProfileImage: {
		invalidatesTags: ["Users", "Me"] as AddTagTypes
	},
	CompleteUserInviteAsSignedInUser: {
		invalidatesTags: ["UserInvites", "Users", "Me"] as AddTagTypes
	},
	UnignoreMissingData: {
		invalidatesTags: ["Me"] as AddTagTypes
	},
	UnlinkFusionAuthUser: {
		invalidatesTags: ["Users", "Me"] as AddTagTypes
	},
	UpdateUserFullName: {
		invalidatesTags: ["Users"] as AddTagTypes
	},
	UpdateUserRoles: {
		invalidatesTags: ["Users", "Me"] as AddTagTypes
	}
};
